import React, { useMemo, useEffect, useState } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import { GlobalFilter } from '../jsx/components/table/FilteringTable/GlobalFilter';
import { Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { Col, Row,Table } from 'react-bootstrap';
import pMinDelay from "p-min-delay";
import { IMAGES, SVGICON } from '../jsx/constant/theme';
import loadable from "@loadable/component";

import AddVisitorLine from '../jsx/components/Dashboard/elements/AddVisitorLine';

import '../jsx/components/table/FilteringTable/filtering.css';
import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnAsnafReport';
import MOCK_DATA from '../jsx/components/table/FilteringTable/MOCK_DATA_2.json';
const TotalDeposit = loadable(() =>
	pMinDelay(import("../jsx/components/Dashboard/elements/TotalDeposit"), 1000));
export const AsnafReport = () => {
  const columns = useMemo(() => COLUMNS, []);
   const [data1, setData1] = useState([]);
   const [startMonth, setStartMonth] = useState(0);

 
  const printInvoice = () => {
    const printContents = document.getElementById('invoiceDiv').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }; 
 
   
///////////////////////////////////////
 const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [itemName, setItemName] = useState("");
  const [data, setData] = useState([]);
  const [data3, setData3] = useState([]); // For item names

  // Fetch tool names for the select options (assuming API or local data)
  useEffect(() => {
    fetchTools();
  }, []);

  const fetchTools = async () => {
    // Simulating an API call to fetch tools
  try {
    const response = await fetch("https://suhba.education.com.ly/back/api/order_items");
    const res = await response.json();

    // Adjust based on your actual response structure
    setData(res.tools);       // Example: list of rented tools with totals
    setData3(res.ToolsItem);  // Example: list of tool names for the dropdown
  } catch (error) {
    console.error("Failed to fetch tools:", error);
  } };

  const handleSearch = async () => {
    // Construct the query parameters based on the filters
    let query = "";
    if (startDate) query += `&startDate=${startDate}`;
    if (endDate) query += `&endDate=${endDate}`;
    if (itemName) query += `&itemName=${itemName}`;

    // Fetch data based on selected filters
    const filteredData = await fetch(`https://suhba.education.com.ly/back/api/gettools?${query}`)
      .then(res => res.json())
      .catch(err => console.log(err));

    // Assuming the API returns the data in the correct format
    setData1(filteredData.tools);
  };

  const handleClearSearch = () => {
    setStartDate("");
    setEndDate("");
    setItemName("");
    setData1([]); // Clear the data
  };

  
 const chartCardBlog = [
	{
	  title: 'الادوات الاكنر إيجارا',
	  item: data.length > 0 ? data[0].TName : 'No Data', // Check if data array is not empty
	  svg: <i className="fa-solid fa-circle-arrow-up " style={{ color: '#452B90' }}></i>,
	  number: data.length > 0 ? data[0].totalQuantity : 0, // Provide default value if data array is empty
	  chartTheme: 'var(--primary)',
	  cardColor: 'primary'
	},

	{
	  title: 'الادوات الاقل إيجارا',
	  item: data.length > 0 ? data[data.length - 1].TName : 'No Data', // Check if data array is not empty
	  svg: <i className="fa-solid fa-circle-arrow-down " style={{ color: '#58bad7' }}></i>,
	  number: data.length > 0 ? data[data.length - 1].totalQuantity : 0, // Provide default value if data array is empty
	  chartTheme: '#58bad7',
	  cardColor: 'info'
	}
  ];
  const headersTitle = [
    // HallID 	HallName 	HallAddress 	HallContactNumber 	TItemPrice 	UserID 	created_at 	updated_at 	PreName 	
      {label:'اسم الاداة', key:'TName'}, 
      {label:'اجمالي عدد القطع الني تم إيجارها', key:'totalQuantity'}, 
      {label:'سعر القطعة', key:'TItemPrice'}, 
      {label:' اجمالي الدخل من هدا الاداة', key:'totalprice'}, 
       
  ]
    const csvlink = {
      headers : headersTitle,
      data : data,
      filename: "csvfile.csv"
    }
  return (
    <>
	  <div className="card-body py-0 custome-tooltip mb-0">
                            <div className="row mx-1 ">
                                {chartCardBlog.map((item, ind)=>(
                                    <div className="col-xl-6 col-sm-6 " key={ind}>
                                        <div className="card">
                                            <div className="card-header p-2 border-0">
                                                <div className="d-flex">
                                                    <div className={`icon-box rounded-circle bg-${item.cardColor}-light`}style={{color:'#D99512'}}>
                                                     {item.svg}
                                                    </div>
                                                    <div className="ms-2 add-visit">
                                                        <h6 className="mb-0 me-2">{item.title} : {item.item}</h6>
                                                        <span className='me-2'>{item.number}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body p-0 custome-tooltip">                                            
                                                <AddVisitorLine colorTheme ={item.chartTheme} />
                                            </div>
                                        </div>
                                    </div>
                                ))}                                
                            </div>                            
                        </div>
      
	  <div className="container-fluid pt-0" >
        <Row>
          <Col lg="12">
            <div className="card">
           <div className="card-header">
              <h4 className="heading mb-0">المعدات</h4>
              <div>
                <Link onClick={printInvoice} to="#" className="btn btn-secondary btn-sm ms-1" data-bs-toggle="offcanvas">
                  <i className="fa-solid fa-print ms-1" /> طباعه
                </Link>
              </div>
            </div>
            <div className="row" style={{ display: 'flex', marginTop: '20px', marginRight: '20px' }}>
              {/* Start Date */}
              <div className="col-md-3" style={{ display: 'flex' }}>
                <label htmlFor="startDate" className="form-label ms-2 mt-1">تاريخ البداية</label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                />
              </div>

              {/* End Date */}
              <div className="col-md-3" style={{ display: 'flex' }}>
                <label htmlFor="endDate" className="form-label ms-2 mt-1">تاريخ النهاية</label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                />
              </div>

              {/* Item Name */}
              <div className="col-md-4" style={{ display: 'flex' }}>
                <label htmlFor="itemName" className="form-label ms-2 mt-1" style={{ whitespace: "nowrap" }}>الاداة</label>
                <select
                  className="default-select form-control"
                  name="FoodTItemID"
                  value={itemName}
                  onChange={e => setItemName(e.target.value)}
                >
                  <option data-display="Select">اختر من القائمة</option>
                  {data3.map((row) => (
                    <option key={row.TItemID} value={row.TItemID}>
                      {row.TName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Search and Clear buttons */}
              <div className="col-md-2">
                <button className="btn btn-primary btn-sm me-1" onClick={handleSearch}>ابحث</button>
                <button className="btn btn-secondary btn-sm me-1" onClick={handleClearSearch}>الغاء</button>
              </div>
            </div>

            <div className="table-responsive m-3" id="invoiceDiv">
              <Table responsive className="primary-table-bordered table-hover">
                <thead className="thead-primary">
                  <tr className='pe-2'>
                    <th>اسم الاداة</th>
                    <th>اجمالي عدد القطع التي تم إيجارها</th>
                    <th>سعر القطعة</th>
                    <th>اجمالي الدخل من هذه الاداة</th>
                  </tr>
                </thead>
                <tbody>
                  {
  data1.length > 0 ? (
    data1.map((item, index) => (
      <tr key={index}>
        <td>{item.TName}</td>
        <td>{item.totalQuantity}</td>
        <td>{item.TItemPrice}</td>
        <td>{item.totalPrice}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4" className="text-center">لا توجد بيانات لعرضها</td>
    </tr>
  )
}

                </tbody>
              </Table>
            </div>
          </div>
           </Col>
        </Row>
      </div>
    </>
  );
};

export default AsnafReport;
